import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OpenAIOutlinedSvg from "@ant-design/icons-svg/es/asn/OpenAIOutlined";
import AntdIcon from '../components/AntdIcon';
var OpenAIOutlined = function OpenAIOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: OpenAIOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(OpenAIOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'OpenAIOutlined';
}
export default RefIcon;